<template>
  <p v-if="loading" style="text-align: center;padding: 20px">
    <span style="font-size: 25px;">
        <i class="fa fa-spinner fa-spin"></i> Loading...
    </span>
  </p>
  <b-row v-else>
    <b-col cols="12" xl="12" sm="12">
      <transition name="slide">
        <b-card no-body>
          <b-tabs card>
            <!-- <b-tab title="General" active>
              <b-card-text>General</b-card-text>
            </b-tab> -->
            <b-tab title="Mail Settings">
              <form @submit.prevent="updateSettings">
                <b-card-text>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Mail Driver</label>
                      <div class="col-sm-10">
                        <input type="text" v-model="settings.mail_driver" autocomplete="off" class="form-control" placeholder="Ex. mailgun" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Mail Host</label>
                      <div class="col-sm-10">
                        <input type="text" autocomplete="off" v-model="settings.mail_host" class="form-control" placeholder="Ex. smtp.mail.com" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputPassword" class="col-sm-2 col-form-label">Mail Port</label>
                      <div class="col-sm-10">
                        <input type="number" class="form-control" v-model="settings.mail_port" placeholder="Ex. 587" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="inputPassword" class="col-sm-2 col-form-label">Mail From Address:</label>
                      <div class="col-sm-10">
                        <input type="email" autocomplete="off" class="form-control" v-model="settings.mail_from_address" placeholder="Ex. support@pennylender.com" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Mail From Name:</label>
                      <div class="col-sm-10">
                        <input type="text" autocomplete="off" class="form-control" v-model="settings.mail_from_name" placeholder="Ex. Pennylender" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Username</label>
                      <div class="col-sm-10">
                        <input type="text" autocomplete="off" class="form-control" v-model="settings.mail_username" placeholder="Ex. john" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Mail Encryption Type</label>
                      <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="settings.mail_encryption" placeholder="Ex. TLS or SSL" :required="true" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Password</label>
                      <div class="col-sm-10">
                        <input type="text" class="form-control" v-model="settings.mail_password" placeholder="Ex. *********" :required="true" />
                      </div>
                    </div><hr/>
                    <button class="btn btn-md btn-primary" type="submit"><i class="fa fa-cog"></i> Update Settings</button>
                </b-card-text>
              </form>
            </b-tab>
            <!-- <b-tab title="Loan Eligibity Settings">
              <b-card-text>Loan Eligibity Settings</b-card-text>
              <form @submit.prevent="updateSettings">
                <b-card-text>
                    <div class="form-group row">
                      <label class="col-sm-2 col-form-label">Mail Driver</label>
                      <div class="col-sm-10">
                        <input type="text" v-model="settings.mail_driver" autocomplete="off" class="form-control" placeholder="Ex. mailgun" :required="true" />
                      </div>
                    </div>
                </b-card-text>
              </form>
            </b-tab> -->
          </b-tabs>
        </b-card>
      </transition>
    </b-col>
  </b-row>
</template>

<script>
import { baseURL } from '../../shared/utils'

export default {
  name: 'SystemSettings',
  data: () => {
    return {
      loading: false,
      settings: {
        mail_from_address: '',
        mail_host: '',
        mail_from_name: '',
        mail_password: '',
        mail_username: '',
        mail_port: '',
        mail_driver: '',
        mail_encryption: ''
      },
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    updateSettings() {
      this.loading = true;
      this.$http.post(`${baseURL}settings/store`, this.settings)
      .then(({data}) => {
        this.loading = false;
        this.$swal('Updated Successfully!','Settings updated successfully.','success');
      })
      .catch(function (error) {
        this.loading = false;
        console.log(error);
      });
    },
    fetchData() {
      this.loading = true;
      this.$http.get(`${baseURL}settings`)
      .then(({data}) => {
        this.loading = false;
        this.settings = data.datas;
      })
      .catch(function (error) {
        this.loading = false;
        console.log(error);
      });
    }
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
</style>